/**
 * @generated SignedSource<<4629bc32b0340b4025c85d917d7c83d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useCreateHubSpotContactMutation$variables = {};
export type useCreateHubSpotContactMutation$data = {
  readonly createHubspotContact: {
    readonly __typename: "User";
    readonly hubspotContactId: string;
  };
};
export type useCreateHubSpotContactMutation = {
  response: useCreateHubSpotContactMutation$data;
  variables: useCreateHubSpotContactMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hubspotContactId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useCreateHubSpotContactMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "createHubspotContact",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useCreateHubSpotContactMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "createHubspotContact",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5e639bcb8f3d4aaed0e40998a2b8500c",
    "id": null,
    "metadata": {},
    "name": "useCreateHubSpotContactMutation",
    "operationKind": "mutation",
    "text": "mutation useCreateHubSpotContactMutation {\n  createHubspotContact {\n    __typename\n    hubspotContactId\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "15c834cd3586baba6295608e4a61ddbd";

export default node;
